import { parseApiWallClock } from './apiDate';

/**
 * Owner decision 2026-09-08: completing a match is open to anyone assigned to it, but NOT before
 * kickoff. Results entered for a match that has not been played are indistinguishable from a real
 * completion, and they are paid.
 *
 * `Match.ScheduledDateTime` is the COMPANY's wall-clock kickoff, not an instant, so the honest
 * comparison happens on the server (`TournamentHelpers.HasMatchStarted`, which resolves the company
 * timezone). The client compares against the viewer's own clock, which is exact for a viewer in the
 * company's timezone and off by the offset difference otherwise. That is fine for what this is used
 * for: an affordance that stops the ordinary mistake. The server remains the gate.
 *
 * When the API starts sending a resolved `hasStarted` flag on the match view, it wins.
 *
 * A match whose kickoff cannot be read is treated as started — never dead-end a user on missing data.
 */
export const hasMatchKickedOff = (
  match: { scheduledDateTime?: string | null; hasStarted?: boolean } | null | undefined,
  now: Date = new Date(),
): boolean => {
  if (!match) return true;
  if (typeof match.hasStarted === 'boolean') return match.hasStarted;
  const kickoff = parseApiWallClock(match.scheduledDateTime);
  return kickoff ? kickoff.getTime() <= now.getTime() : true;
};
